import {PDF} from "~/services/PDF/PDF";

const pdf = new PDF();
(window as Window).signToDoc = pdf;
